<template>
  <div id="app" style="position: relative;">
    <el-popover
    style="position: absolute; top: 60px;"
      transition="el-fade-in-linear"
      v-model="showMention"
      :visible-arrow="false"
      placement="top-start"
      width="300"
      trigger="manual"
      :inert="showMention ? false : true">
      <div
        class="overflow-auto"
        style="max-height: 400px">
        <div
          :key="index"
          v-for="(item, index) in itemsInMention">
          <div
            class="pointer pin d-flex rounded-1 align-items-center py-2 px-1"
            :class="selectedMention === index && 'mention-selected'"
            @click="addMentioned(item)">
            <el-avatar
              class="mx-2"
              :src="item.avatar"
              v-if="item.id != '-1'"
              style="min-width: 32px; min-height: 32px; max-width: 32px; max-height: 32px" />
            <div
              class="d-flex align-items-center"
              v-else>
              <el-avatar
                class="mx-2"
                src="https://chat.zalo.me/assets/icn_mentionall.b2c245e08bb8372941a2ae03865b67e4.png"
                style="min-width: 32px; min-height: 32px; max-width: 32px; max-height: 32px" />
              <div class="me-2">Báo cho cả nhóm</div>
            </div>
            <div
              v-bind:class="item.id === '-1' ? 'c-blue' : ''"
              class="me-2">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div slot="reference"></div>
    </el-popover>
    <vue-editor
      ref="editor"
      v-model="content"
      :editorToolbar="customToolbar">
    </vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-quill-editor";

export default {
  components: {
    VueEditor,
  },
  props: ["conversation","members"],

  watch: {
    content(newContent,oldContent) {
      const contentText = this.handleHtmlToPlainText(newContent); 
      const oldContentText = this.handleHtmlToPlainText(oldContent);
      
      if (contentText !== oldContentText && contentText.includes('@')) {
        this.getMentionComponent();
      }
      else{
        this.showMention = false
      }
      if(newContent){
        this.listMentions.forEach(item =>{
          if(!this.checkMention(contentText,item.name)){
            const member = JSON.parse(JSON.stringify(this.members)).find(s => s.id === item.uid );             
            this.itemsInMention.push(member);
          }
        })
      }
    },
  },

  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ size: ["small", false, "large", "huge"] }], // Cỡ chữ
        [{ color: ["#DB342E", "#F27806", "#F7B503", "#15A85F", "#050A19"] }], // Màu chữ
        [{ list: "ordered" }, { list: "bullet" }], // Đánh số, gạch đầu dòng
        [{ indent: "-1" }, { indent: "+1" }], // Lùi đầu dòng
        ["clean"], // Xóa định dạng
        [
          {
            content: "customUndo",
            onclick: () => this.editor.history.undo(),
          },
          {
            content: "customRedo",
            onclick: () => this.editor.history.redo(),
          },
        ],
      ],
      content: "",
      listMentions: [],
      searchTextMention: "",
      showMention : false,
      selectedMention: 0,
    };
  },
  computed : {
    itemsInMention() {
      let index = this.members.findIndex((s) => s.id == "-1");
      let response = JSON.parse(JSON.stringify(this.members));
      if (index === -1) {
        let item = { id: "-1", name: "All" };
        response.unshift(item);
      }
      if (this.searchTextMention) {
        let arr = response.filter((s) => {
          return s.name.toLowerCase().includes(this.searchTextMention.toLowerCase());
        });
        if (arr.length === 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.showMention = false;
        }
        if (this.listMentions.length > 0) {
          return arr.filter((s) => !this.listMentions.map((t) => t.uid).includes(s.id));
        }
        return arr;
      } else {
        if (this.listMentions.length > 0) {
          return response.filter((s) => !this.listMentions.map((t) => t.uid).includes(s.id));
        }
        return response;
      }
    },
  },
  methods: {
    EmojiPickup(emoji) {
      this.content = this.content += emoji;
    },
    QuickMessagePickup(message) {
      this.content = message.content;
    },
    parseHtmlToObject(html) {
      const object = {
        content: "",
        params: ""
      };
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const textNodes = [];
      let cursor = 0;
      let isFirstP = true;
      
      const styles = [];

      const processNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          textNodes.push({ text, start: cursor });
          cursor += text.length;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const style = {};
          
          if (node.tagName === 'P' || node.tagName === "LI") {
            if (!isFirstP) {
              const lineBreak = '\n';
              textNodes.push({ text: lineBreak, start: cursor });
              cursor += lineBreak.length;
            }
            isFirstP = false;
          }
          
          if (node.style.fontWeight === "bold" || node.tagName === 'STRONG') style.b = 'b';
          if (node.style.fontStyle === "italic" || node.tagName === 'EM') style.i = 'i';
          if (node.style.textDecoration.includes("underline") || node.tagName === 'U') style.u = 'u';
          if (node.style.textDecoration.includes("line-through") || node.tagName === 'S') style.s = 's';
          if (node.style.fontSize) style.f = `f_${parseInt(node.style.fontSize)}`;
          if (node.style.color) {
            const rgbColor = node.style.color;
            const hexColor = rgbColor.startsWith("rgb") ? this.rgbToHex(...rgbColor.match(/\d+/g).map(Number)) : rgbColor;
            style.c = `c_${hexColor.slice(1)}`;
          }
          if (node.tagName === "LI") {
            style.lst = node.parentElement.tagName === "UL" ? "lst_1" : "lst_2";
          }
          if (node.style.paddingLeft) {
            style.ind = `ind_${parseInt(node.style.paddingLeft)}`;
          }
          if (node.classList.contains('ql-size-huge')) {
            style.f = "f_20";
          }
          if (node.classList.contains('ql-size-large')) {
            style.f = "f_18";
          }
          if (node.classList.contains('ql-size-small')) {
            style.f = "f_13";
          }
          
          const start = cursor;
          node.childNodes.forEach(processNode);
          const len = cursor - start;
          
          if (Object.keys(style).length > 0) {
            const styleString = Object.values(style).join(",");
            styles.push({ start, len, st: styleString });
          }
        }
      };
      
      processNode(doc.body);
      object.content = JSON.stringify({
        thumb: "",
        description: "",
        action: "rtf",
        childnumber: 0,
        href: "",
        title: textNodes.map(t => t.text).join(""),
      });
      object.params = JSON.stringify({ styles, ver: 0 });
      
      return object;
    },
    rgbToHex(r, g, b) {
      const toHex = (value) => {
        const hex = value.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      };
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    },
    sendMessageForm() {
      // Xử lý content ở đây
      const messageObj = this.parseHtmlToObject(this.content.trim().replace(/^\s+/gm, ''));
      
      const message = JSON.parse(messageObj.content).title; // xử lý content ở đây
      const textProperties = JSON.stringify({
        styles: JSON.parse(messageObj.params).styles,
        ver: 0
      });

      if (this.conversation.group) {
        let req = {
          accountId: this.conversation.accountId,
          groupId: this.conversation.toId,
          message: message,
          textProperties: textProperties,
          mentions: this.listMentions,
        };
        
        this.content = "";
        this.$http
           .post("/api/message/group/mention", req)
           .then()
           .finally(() => {
             this.listMentions = [];
           });
      } else {
        let req = {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          message: message,
          conversationId: this.conversation.id,
          textProperties: textProperties,
        };
        this.content = "";
        this.$http.post("/api/message/sms", req);
      }
    },
    handleHtmlToPlainText(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      return Array.from(doc.body.childNodes)
        .map(node => node.textContent.trim())
        .join('\n');
    },
    restoreMention() {
      this.showMention = false;
      this.searchTextMention = null;
      this.selectedMention = 0;
    },
    addMentioned(item) {
      const contentText = this.content;
      const index = contentText.length; 
      
      const contentParse = this.parseHtmlToObject(this.content);
      const position = this.getLastKeyBeforeCaret(contentParse.length).keyIndex;

      const  keyIndex  = contentText.lastIndexOf("@");
      const firstContent = contentText.substring(0,keyIndex + 1);
      const secondContent = contentText.substring(keyIndex + 1, index);
      this.content = firstContent + item.name + " " + secondContent;
      
      
      let mention = {};
      mention.name = item.name;
      mention.uid = item.id;
      mention.pos = position;
      mention.length = item.name.length + 1;

      this.listMentions.push(mention);
      if (item.id === '-1') {
        this.members.unshift({
          id: "-1",
          name: "All",
        });
      }

      this.$nextTick(() => {
        const editor = this.$refs.editor.quill;

        if (editor) {
          const cursorPos = this.content.substring(0, this.content.lastIndexOf("@") + 1).length + item.name.length + 1;
          const range = editor.getSelection();
          
          if (range) {
            editor.setSelection(cursorPos, 0); 
          } else {
            editor.setSelection(cursorPos, 0); 
          }
          editor.focus();
        }
      });
      this.restoreMention();
    },
    getMentionComponent() {
      const contentText = this.handleHtmlToPlainText(this.content);
      const index = contentText.length;
      if (index >= 0) {
        const { keyIndex } = this.getLastKeyBeforeCaret(index);
        const searchText = this.getLastSearchText(index, keyIndex);

        if (!(keyIndex < 1 || /\s/.test(contentText[keyIndex - 1]))) {
          return (this.showMention = false);
        }
        if (searchText != null) {
          this.searchTextMention = searchText;
          this.showMention = true;
        } else {
          this.restoreMention();
        }
      }
    },
    getLastKeyBeforeCaret(caretIndex) {
      const contentText = this.handleHtmlToPlainText(this.content);
      let _this = contentText;
      const [keyData] = ["@"]
        .map((key) => ({
          key,
          keyIndex: _this.lastIndexOf(key, caretIndex - 1),
        }))
        .sort((a, b) => b.keyIndex - a.keyIndex);
      return keyData;
    },
    getLastSearchText(caretIndex, keyIndex) {
      const contentText = this.handleHtmlToPlainText(this.content);
      const caretPosition = this.getCaretPosition();
      
      if (keyIndex !== -1) {
        let searchText = null;

        if(caretIndex === keyIndex + 1){
          searchText = contentText.substring(keyIndex + 1, caretIndex);
        }else{
          if(caretPosition === keyIndex + 1){
            searchText = contentText.substring(keyIndex + 1, caretIndex);
          
            let endIndex = searchText.indexOf(" ");
            let result = endIndex === -1 ? searchText : searchText.substring(0, endIndex); 
            
            if(result.length > 0){
              searchText = result;
            }else{
              const nonSpace = searchText.length; 
              searchText = searchText.slice(0, -(caretIndex-keyIndex-nonSpace-1));
            }
          }
        }
        if (!/\s/.test(searchText)) {
          return searchText;
        }
      }
      return null;
    },
    getCaretPosition() {
      const editor = this.$refs.editor;
      const quill = editor.quill;
      const position = quill.getSelection();
      
      if (position) {
        return position.index; 
      }
      return null; 
    },
    checkMention(content,mention){
      const regex = new RegExp(`\\${mention}(\\s|$)`);
      return regex.test(content);
    }
  },
  created() {
    this.$bus.$on("emoji_click", (data) => {
      this.EmojiPickup(data);
    });
    this.$bus.$on("selectQuickMessage", (data) => {
      this.QuickMessagePickup(data);
    });
    this.$bus.$on("sendMessageForm", () => {
      this.sendMessageForm();
    });
  },
  beforeDestroy() {
    this.$bus.$off('sendMessageForm')
    this.$bus.$off('selectQuickMessage')
  }
};
</script> 
<style >
.quillWrapper {
  width: 100%;
  border-right: thin solid #d3d7de;
}
#quill-container {
  height: 200px !important;
  width: 100%;
  border: none;
}
.ql-editor {
  padding: 0 !important;
}
.ql-toolbar.ql-snow {
  border: none !important;
  padding: 8px 0 !important;
  margin-left: -8px;
}
</style>